"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@domonda/ui/styles");
const styles = styles_1.createStyles({
    root: {
        '& > div, & .react-datepicker-wrapper, & .react-datepicker__input-container': {
            display: 'inherit',
            '& input': {
                width: '100%',
            },
        },
    },
    popper: {
        // NOTE: here we use `!important` because the default `react-datepicker` stylesheet is prioritized
        zIndex: '999 !important',
        '& .react-datepicker__triangle': {
            left: '50%',
        },
    },
    calendar: {
        '& .react-datepicker__navigation': {
            boxSizing: 'border-box',
        },
    },
});
exports.decorate = styles_1.withStyles(styles);
